import { render, staticRenderFns } from "./BottomNavigationApp.vue?vue&type=template&id=9461a450"
import script from "./BottomNavigationApp.vue?vue&type=script&lang=js"
export * from "./BottomNavigationApp.vue?vue&type=script&lang=js"
import style0 from "./BottomNavigationApp.vue?vue&type=style&index=0&id=9461a450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports